import * as React from 'react';
import { observer } from 'mobx-react';
import { PRODUCT_NOTIFY_ME } from '@estee/elc-service-view-names';
import { configConsumer, ServiceView } from '@estee/elc-service';
import { Sku } from '../../domain/entities/Sku';
import { InventoryStatus } from '../../constants/InventoryStatuses';
import {
    BACK_IN_STOCK_SUBSCRIPTION,
    COMING_SOON_SUBSCRIPTION
} from '../../constants/SubscriptionTypes';
import { serviceName } from '../../../service-setup/packageInfo';
import { IProductNotifyMeCTAConfig } from '~interfaces/IProductCTA';

export interface IMapping {
    [key: string]: string;
}
export interface IProductNotifyMeCTA {
    ctaType?: string;
    selectedSku: Sku;
    skuId?: string;
    config?: IProductNotifyMeCTAConfig;
    customNotifyMeLabel?: string;
}
@configConsumer(['enableNotifyMe', 'waitlist', 'compliance', 'customNotifyMeLabel'])
@observer
export class NotifyMeCTA extends React.Component<IProductNotifyMeCTA> {
    private notifyMeSubscriptionType(inventoryStatus: string) {
        const subscriptionTypes: IMapping = {
            [InventoryStatus.TempOutOfStock]: BACK_IN_STOCK_SUBSCRIPTION,
            [InventoryStatus.ComingSoon]: COMING_SOON_SUBSCRIPTION
        };

        return subscriptionTypes[inventoryStatus] || '';
    }

    public render() {
        const { config, selectedSku, customNotifyMeLabel, ctaType } = this.props;
        const { enableNotifyMe, waitlist, compliance } = config as IProductNotifyMeCTAConfig;

        const {
            skuId,
            partialParentProduct,
            inventoryStatus,
            perlgem: { SKU_BASE_ID }
        } = selectedSku;

        const { displayName, productUrl } = partialParentProduct;

        const notifyMeConfig = {
            productDisplayName: displayName,
            productUrl: productUrl,
            productImageUrl: partialParentProduct.defaultImage.src,
            skuId: skuId,
            subscriptionType: this.notifyMeSubscriptionType(inventoryStatus),
            altText: partialParentProduct.defaultImage.alt,
            compliance,
            enableNotifyMe,
            waitlist,
            skuBaseId: SKU_BASE_ID,
            zIndex: '100001',
            customNotifyMeLabel,
            ctaType
        };

        return (
            <ServiceView
                name={PRODUCT_NOTIFY_ME}
                serviceName={serviceName}
                config={notifyMeConfig}
            />
        );
    }
}
